import { render } from "./TreeDownMilestone.vue?vue&type=template&id=1d5fc4a1"
import script from "./TreeDownMilestone.vue?vue&type=script&lang=js"
export * from "./TreeDownMilestone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__